angular.module("avlib").directive("avCollapsiblePanel", function(){
	return {
		template: require("!html-loader!./CollapsiblePanelTemplate.html"),
		restrict: "E",
		transclude: true,
		scope: {
			/*
			 * Inicialmente o atributo se chamava title, mas por conta de conflito com o a
			 * funcionalidade de tooltips do framework Bootstrap, foi renomeado para panelTitle.
			 * Ver tarefa Mantis 463.
			 */
			panelTitle: '=',
			titleSummary: '&',
			/*
			 * A operação em modo transclude impede que componentes internos ao painel modifiquem
			 * objetos no escopo externo. Isso acaba criando dificuldades na implementação de algumas
			 * interfaces. Para contornar esse problema, criamos o campo model com o intuito de
			 * possibilitar a passagem de referência para algum objeto que fará a ponte entre
			 * o mundo interno ao componente e o mundo externo.
			 */
			model: '=',
			// Indica se o painel deve inicialmente estar comprimido
			initCollapsed: '=collapsed',
		},
		
		link: function(scope, element, attrs){
			/*
			 * Quando o painel deve ser iniciado em estado compactado, forçávamos seus atributos com Javascript.
			 * Porém, essa abordagem fazia com que o painel fosse mostrado por alguns instantes em estado
			 * expandido e só depois compactado. Para resolver esse problema foi necessário aplicar uma
			 * classe CSS (init-collapsed) para forçar o estado inicial compactado quando necessário.
			 */
			// if (scope.collapsed){
			//	var body = $(element).find(".av-collapsible-panel-body");
			// 	scope.paddingTop = body.css('padding-top');
			// 	scope.paddingBottom = body.css('padding-bottom');
			// 	body.css('height', '0');
			// 	body.css('overflow-y', 'hidden');
			// 	body.css('padding-top', '0');
			// 	body.css('padding-bottom', '0');
			// }

			// Guardando o corpo do painel para ser utilizado posteriormente
			scope.body = $(element).find(".av-collapsible-panel-body");
		},

		controller: ["$scope", function($scope){
			/*
			 * A variável collapsed indica se o painel encontra-se comprimido ou não. Ela é inicializada
			 * com a configuração escolhida pelo usuário.
			 */
			$scope.collapsed = $scope.initCollapsed;
			/*
			 * Se o painel se inicia compactado, ele possui a classe CSS init-collapsed, responsável
			 * por eliminar sua altura e paddings verticais. Precisamos então realizar uma manobra
			 * para obter os valores de padding que devem ser aplicados quando o painel for expandido.
			 * Tentamos várias abordagens, mas a única que deu resultados minimamente satisfatórios foi
			 * usar um timer para obter esses valores instantes após o componente ter sido incluído no DOM.
			 */
			if ($scope.initCollapsed){
				setTimeout(function(){
						var body = $scope.body;
						// Garantindo que o corpo do painel não irá ser apresentado quando tirarmos a classe "init-collapsed"
						body.css('display', 'none');
						// Removendo a classe CSS para que possamos ler os paddings originais do elemento
						body.removeClass("init-collapsed");
						// Guardando os paddings para serem restaurados quando o painel for expandido.
						// O valor da altura não conseguimos recuperar nesse momento.
						$scope.paddingTop = body.css('padding-top');
						$scope.paddingBottom = body.css('padding-bottom');
						// Garantindo que o painel permaneça compactado, no mesmo estado que estaria se
						// tivesse sido minimizado pelo click na barra de títulos
						body.css('height', '0');
						body.css('overflow-y', 'hidden');
						body.css('padding-top', '0');
						body.css('padding-bottom', '0');
						// Retornando o display para seu valor original. Assim o painel será exibido quando for expandido
						body.css('display', 'unset');
						// Removendo esse sinalizador do escopo. Não queremos que classe init-collpased seja reaplicada.
						$scope.initCollapsed = false;
				}, 1000);
			}

			$scope.titleClicked = function(event){
				var titleBar = $(event.currentTarget);
				var filter = titleBar.parents('.av-collapsible-panel');
				var body = titleBar.next('.av-collapsible-panel-body');
				/*
				 * Abaixo controlamos a altura do corpo do painel, ajustando os valores desejados
				 * ao início e ao final da animação de compactação ou expansão. Não é possível
				 * controlar essa propriedade exclusivamente via folha de estilo de forma satisfatória.
				 * Para mais detalhes, ver a tarefa Mantis #508.
				 */
				if (!$scope.collapsed){
					/*
					 * Salvando as dimensões do painel para restaurá-las posteriormente, na expansão:
					 */
					$scope.paddingTop = body.css('padding-top');
					$scope.paddingBottom = body.css('padding-bottom');
					$scope.outerHeight = body.outerHeight();

					requestAnimationFrame(function() {
						body.css('height', $scope.outerHeight + 'px');
						/*
						 * No corpo do painel de filtragem queremos utilizar o estilo overflow-y:auto; para
						 * garantir que o scroll vertical apareça apenas quando necessário. Desta forma,
						 * garantimos melhor aparência para os paineis que, em geral, dispensam o scroll
						 * comportando confortavelmente todos o seu contéudo. Porém, mesmos nesses casos,
						 * durante o processo de compactação, uma vez que sua altura é naturalmente reduzida,
						 * o painel deixa de comportar os componentes. Com isso, o scroll é exibido por alguns
						 * instantes durante a compactação, causando um efeito visual indesejado.
						 * Resolvemos esta questão mudando o atributo overflow para hidden durante a compactação.
						 */
						body.css('overflow-y', 'hidden');
						// on the next frame (as soon as the previous style change has taken effect),
						// have the element transition to height: 0
						requestAnimationFrame(function() {
							body.css('height', '0');
							body.css('padding-top', '0');
							body.css('padding-bottom', '0');
							requestAnimationFrame(function() {
								$scope.collapsed = true;
								/*
								 * Como a alteração no escopo foi feita por timer, fora do ciclo de processamento
								 * do Angular (digest cycle), é necessário chamar $apply para garantir que as alterações
								 * na view decorrentes desta alteração no modelo ocorram de fato.
								 */
								$scope.$apply();
							});
						});
					});					
				}else{
					body.css('padding-top', $scope.paddingTop);
					body.css('padding-bottom', $scope.paddingBottom);
					/*
					 * Se esta é a primeira expansão de um painel que foi inicializado já compactado, a variável
					 * outerHeight não terá sido inicializada durante o processo de compactação. Precisaremos
					 * estimar agora qual o tamanho ideal para o painel esticado. O método outerHeight não
					 * funciona quando o elemento não está renderizado na tela. Utilizaremos o artifício da
					 * propriedade "scrollHeight", para um resultado aproximado.
					 */
					if ($scope.outerHeight === undefined){
						$scope.outerHeight = body.prop("scrollHeight");
					}

					body.css('height', $scope.outerHeight + 'px');
					
					filter.one('transitionend', function(e) {
						body.css('height', "unset");
						body.css('overflow-y', 'auto');
						/* 
						 * Como a alteração no escopo foi feita por timer, fora do ciclo de processamento
						 * do Angular (digest cycle), é necessário chamar $apply para garantir que as alterações
						 * na view decorrentes desta alteração no modelo ocorram de fato.
						 */
						$scope.collapsed = false;
						$scope.$apply();
					});					
				}
			};
		}],
	};
});
